import PropTypes from "prop-types";

export const careerExpertQuestionType = PropTypes.shape({
  orderNum: PropTypes.number,
  question: PropTypes.string,
  answer: PropTypes.string,
});
